<template>
  <div class="favorite-games">
    <Game
      v-for="game in allGames"
      v-show="game.active"
      :key="game.key"
      :game="game"
    />
  </div>
</template>

<script>
import Game from "./Game"
export default {
  props: ["allGames"],
  components: {
    Game,
  },
}
</script>

<style lang="scss" scoped>
.favorite-games {
  display: flex;
  flex-wrap: wrap;
  margin: 2rem 0;
}
</style>



// WEBPACK FOOTER //
// src/components/navigation/game/FavoriteGames.vue